import React from "react";
import About from "../components/About";
import WhySelectra from "../components/WhySelectra";
import Testimonials from "../components/Testimonials";
import FinalCTA from "../components/FinalCTA";
import PageHero from "../components/PageHero";

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About Selectra Technologies"
        title={["INTELLIGENT SOLUTIONS", "FOR SMART", "INFRASTRUCTURE."]}
        subtitle="A registered office in Thrissur and a branch office in Palakkad, running on one engineering standard."
      />
      <About />
      <WhySelectra />
      <Testimonials />
      <FinalCTA />
    </>
  );
}
